import {Injectable} from "@angular/core";

@Injectable()
export class GlobalData {
  /**
   * Put any global data values you want to use across screens here, e.g.:
   *
   * myValue: string;
   *
   * Use "global.myValue" to refer to it in your screen template, or this.global.myValue in your controller.
   */
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    productCode: string;
    tagSelected: string;
}



// WEBPACK FOOTER //
// ./src/app/globaldata.service.ts